"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonAPIWatchers = commonAPIWatchers;
exports.getCommonServiceData = getCommonServiceData;
exports.resetIdentityLocalData = resetIdentityLocalData;
exports.updateIdentityLocalData = updateIdentityLocalData;
var _effects = require("redux-saga/effects");
var _sagas = require("../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var _actions = _interopRequireWildcard(require("./actions"));
var actions = _actions;
var _utils = require("../../../common/utils/utils");
var _selector = require("./selector");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getCommonServiceData(params) {
  const {
    onSuccess = () => {},
    onFailure = () => {},
    requestParams,
    showLoader = true
  } = (params === null || params === void 0 ? void 0 : params.data) || {};
  try {
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_COMMON_SERVICE_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCommonServiceAPI, tokenData, requestParams);
    const updateData = {
      data: (mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) || {}
    };
    if (requestParams !== null && requestParams !== void 0 && requestParams.wishlist) {
      var _mainResponse$body;
      updateData.data.wishListItems = (mainResponse === null || mainResponse === void 0 || (_mainResponse$body = mainResponse.body) === null || _mainResponse$body === void 0 ? void 0 : _mainResponse$body.wishListItems) || [];
    } else if (requestParams !== null && requestParams !== void 0 && requestParams.loyaltyPoints) {
      var _mainResponse$body2;
      updateData.data.secureDetails = (mainResponse === null || mainResponse === void 0 || (_mainResponse$body2 = mainResponse.body) === null || _mainResponse$body2 === void 0 ? void 0 : _mainResponse$body2.secureDetails) || {};
    } else if (requestParams !== null && requestParams !== void 0 && requestParams.address) {
      var _mainResponse$body3;
      updateData.data.addresses = (mainResponse === null || mainResponse === void 0 || (_mainResponse$body3 = mainResponse.body) === null || _mainResponse$body3 === void 0 ? void 0 : _mainResponse$body3.addresses) || {};
    } else if (requestParams !== null && requestParams !== void 0 && requestParams.locale) {
      var _mainResponse$body4;
      updateData.data.locale = (mainResponse === null || mainResponse === void 0 || (_mainResponse$body4 = mainResponse.body) === null || _mainResponse$body4 === void 0 ? void 0 : _mainResponse$body4.locale) || {};
    }
    yield (0, _effects.call)(updateIdentityLocalData, updateData);
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_COMMON_SERVICE_DATA_API.failure(err));
    onFailure(err);
  }
}
function* updateLocaleData(params) {
  try {
    const {
      onSuccess,
      requestParams
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    yield (0, _effects.put)(actions.UPDATE_LOCALE_DATA_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateLocaleServiceApi, tokenData, requestParams);
    yield (0, _effects.put)(actions.UPDATE_LOCALE_DATA_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    var _params$data;
    yield (0, _effects.put)(actions.UPDATE_LOCALE_DATA_API.failure(err));
    params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 || _params$data.onFailure(err);
  }
}
function* updateIdentityLocalData(params) {
  /**
   * To update the response from core and foundation itself
   **/
  try {
    const serviceOperationsUpdated = yield (0, _effects.select)((0, _selector.serviceDataReducerSelector)());
    if (params !== null && params !== void 0 && params.data) {
      const updatedData = {
        body: {
          ...serviceOperationsUpdated,
          ...(params === null || params === void 0 ? void 0 : params.data)
        }
      };
      yield (0, _effects.put)(actions.GET_COMMON_SERVICE_DATA_API.success(updatedData));
      yield (0, _effects.put)({
        type: _actions.SET_COMMON_SERVICE_DATA,
        data: updatedData
      });
    }
  } catch (err) {}
}
function* resetIdentityLocalData() {
  /**
   * To update the response from core and foundation itself
   **/
  try {
    yield (0, _effects.put)(actions.GET_COMMON_SERVICE_DATA_API.success({}));
    yield (0, _effects.put)({
      type: _actions.SET_COMMON_SERVICE_DATA,
      data: {}
    });
  } catch (err) {}
}
function* captureAreaLead(params) {
  try {
    const {
      onSuccess,
      requestParams
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    yield (0, _effects.put)(actions.CAPTURE_AREA_LEAD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.captureAreaLead, tokenData, requestParams);
    yield (0, _effects.put)(actions.CAPTURE_AREA_LEAD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    var _params$data2;
    yield (0, _effects.put)(actions.CAPTURE_AREA_LEAD_API.failure(err));
    params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 || _params$data2.onFailure(err);
  }
}
function* commonAPIWatchers() {
  yield (0, _effects.takeEvery)(actions.GET_COMMON_SERVICE_DATA, getCommonServiceData);
  yield (0, _effects.takeEvery)(actions.UPDATE_IDENTITY_LOCAL_DATA, updateIdentityLocalData);
  yield (0, _effects.takeLatest)(actions.UPDATE_LOCALE_DATA, updateLocaleData);
  yield (0, _effects.takeEvery)(actions.RESET_IDENTITY_LOCAL_DATA, resetIdentityLocalData);
  yield (0, _effects.takeEvery)(actions.CAPTURE_AREA_LEAD, captureAreaLead);
}